import axios from 'axios'
//import VueAxios from 'vue-axios'

//const serverIP = 'apiGW'

const headers =  {
    'Accept':'*/*',
    'Content-Type':  'application/json',
    'Authorization' : `${process.env.VUE_APP_AUTORITHATION_KEY}`,
    //'Authorization' : `Bearer ${localStorage.getItem("access_token")}`
    }
export const appApiQHs = axios.create({
    //baseURL: `http://${serverIP}:8000`,
    baseURL: `${process.env.VUE_APP_BASE_URL}`,
    // timeout: 4000,
    headers:headers,
})